import React from 'react';
import { Link } from 'react-router-dom';

function PaymentError() {
    return (
        <div className="card m-3">
        <h1 className="card-header">Payment Error</h1>
        <p> There has been an error with your payment..</p>
        <p> Please try a different payment method or try again later. </p>
        <h3><Link to="/contact" className="btn btn-link">Help</Link></h3>
        <hr />
        <h3><Link to="/home" className="btn btn-link">Home</Link></h3>
        </div>

    );
}

export { PaymentError };